import { csv } from 'd3-fetch';
export const API_URL =
  process.env.URL || '';

export const fetchJson = path => {
  return fetch(`${API_URL}/${path}`).then(x => x.json());
};
export const fetchCsv = path => csv(`${API_URL}/${path}`);
